import React from "react";

function Notification() {
  return <h1>Notification</h1>;
}

export default Notification;
